import { atoms } from "#/lib/atoms/atoms";
import { useAtom, useSetAtom } from "jotai";
import { startTransition, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import cookies from "../lib/cookies";

export const useLoggedIn = () => {
  // might need to look at this if we see issues https://github.com/reactivestack/cookies/pull/288#issuecomment-895672629
  const [currentCookies] = useCookies([cookies.options.access_token]);
  const [loggedIn, setLoggedIn] = useState(
    !!currentCookies[cookies.options.access_token],
  );

  const [accessToken, setAccessToken] = useAtom(atoms.accessToken);
  const [mid, setMid] = useAtom(atoms.mid);
  const [orgId, setOrgId] = useAtom(atoms.orgId);

  useEffect(() => {
    const access_token = currentCookies[cookies.options.access_token];
    setLoggedIn(!!access_token);

    // Wrap atom-setters in startTransition so cookie-driven re-keys of
    // useUser / useMerchantQuery / useIntegrations / etc. don't unmount
    // the page subtree (Suspense default) — instead React keeps the prior
    // UI rendered until the new data is ready.
    startTransition(() => {
      if (access_token) {
        if (!accessToken) setAccessToken(access_token);
      } else if (accessToken) {
        setAccessToken(null);
      }

      const merchant_id = currentCookies[cookies.options.merchant_id];
      if (merchant_id) {
        if (!mid) setMid(merchant_id);
      } else if (mid) {
        setMid(null);
      }

      const org_id = currentCookies[cookies.options.org_id];
      if (org_id) {
        if (!orgId) setOrgId(org_id);
      } else if (orgId) {
        setOrgId(null);
      }
    });
  }, [currentCookies, setAccessToken, setMid, setOrgId]);

  return loggedIn;
};
